export default {
  adminButtonLabel: {
    id: 'header_admin_button_admin_label',
    defaultMessage: 'Exit admin account',
  },
  customerButtonLabel: {
    id: 'header_admin_button_customer_label',
    defaultMessage: 'Exit customer account',
  },
  sellerButtonLabel: {
    id: 'header_admin_button_seller_label',
    defaultMessage: 'Exit seller account',
  },
}
